import usePrivateAxios from "@/common/api/usePrivateAxios"
import { MaintenanceSpecificationValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { useMutation } from "@tanstack/react-query"

interface UseCreateEstablishmentCompanyMaintenanceSpecificationProps {
  establishmentCompanyId: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useCreateEstablishmentCompanyMaintenanceSpecification = ({
  establishmentCompanyId,
  onSuccess,
  onError,
}: UseCreateEstablishmentCompanyMaintenanceSpecificationProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createEstablishmentCompanyMaintenanceSpecification'],
    mutationFn: (data: MaintenanceSpecificationValidationSchema) => {
      const payload = {
        maintenance_specifications_attributes: [
          {
            directive_klass: data.directive_klass,
            equipment_category_specifications_attributes: data.equipment_category_specifications_attributes?.map(
              ({ value }) => ({
                category_id: value,
              })
            ),
            equipment_manufacturer_specifications_attributes: data.equipment_manufacturer_specifications_attributes?.map(
              ({ value }) => ({
                manufacturer_id: value,
              })
            ),
            system_specifications_attributes: data.system_specifications_attributes?.map(
              ({ value }) => ({
                system_id: value,
              })
            ),
          },
        ],
      }

      return privateAxios.put(`/establishment/companies/${establishmentCompanyId}/update_maintenance_models`, {
        company: payload,
      });
    },
    onSuccess,
    onError,
  });
}
